module.exports = __webpack_public_path__ + "img/AdobeStock_178863677_Preview.70b198cc.jpeg";